import { render, staticRenderFns } from "./GardenSurface.vue?vue&type=template&id=6a730fd6&"
import script from "./GardenSurface.vue?vue&type=script&lang=ts&"
export * from "./GardenSurface.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports